import React, { useState } from 'react';
import { Row, Col, Alert } from 'reactstrap';

import { connect } from 'react-redux';
import OnlyOnFlaivySite from './OnlyOnFlaivySite';
import { SuggestNewSupplierForm } from './action-forms/supplier';

function SearchNoResult({ sessionUser = {} }) {
  const [suggestionSent, setSuggestionSent] = useState(false);
  const { customerSubUnit, email } = sessionUser;

  const immutableFields = {};

  if (customerSubUnit?.name) {
    immutableFields.yourName = customerSubUnit.name;
  }

  if (email) {
    immutableFields.yourEmail = email;
  }

  return (
    <>
      <Row className="">
        <Col>
          <h2 className="text-center">
            Vi kunde tyvärr inte hitta det du sökte.
          </h2>
        </Col>
      </Row>
      <OnlyOnFlaivySite>
        {!suggestionSent && (
          <Row className="mt-4">
            <Col>
              <h4 className="text-center fw-light">
                Saknar du någon artikel eller leverantör?
              </h4>
            </Col>
          </Row>
        )}
        {suggestionSent && (
          <Row className="mt-4">
            <Col lg={{ offset: 3, size: 6 }}>
              <Alert
                color="primary"
                isOpen={suggestionSent}
                className="fw-bold text-white text-center"
              >
                Tack för ditt tips!
              </Alert>
            </Col>
          </Row>
        )}
        <Row className="my-4">
          <Col lg={{ offset: 3, size: 6 }}>
            <SuggestNewSupplierForm
              onSubmit={() => setSuggestionSent(true)}
              resetOnSubmit
              entity={{}}
              immutableFields={immutableFields}
            />
          </Col>
        </Row>
      </OnlyOnFlaivySite>
    </>
  );
}

const mapStateToProps = ({ authentication: { sessionUser } }) => ({
  sessionUser,
});
export default connect(mapStateToProps)(SearchNoResult);
